import styled from 'styled-components';
import { headlineFontFamily } from 'assets/styles/fonts';

export const Headline2 = styled.h2`
  font-size: ${({ theme }) => theme.fonts.headline2FontSize};
  ${headlineFontFamily};
`;
